import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store'
import { UserModel } from '../../models/UserModel'

export const userSync = () => {
  const userStore = storeToRefs(useStore().user)

  const hasUserData = computed(() => {
    if (userStore.id.value.length > 0 && userStore.last_name.value.length > 0) {
      return true
    } else {
      return false
    }
  })

  const storeUserData = async (data: any) => {
    if (data !== null) {
      useStore().user.setUserData(data)
      //write to device
      const { writeUsersData } = UserModel()
      await writeUsersData(data).catch((error) => console.log(error))
    }
  }

  return {
    hasUserData,
    storeUserData,
  }
}
